package com.kinoshazam.data

import kotlinx.serialization.Serializable

@Serializable
data class AuthTokenRefresh(val refreshToken: String)
